import { derived, writable } from 'svelte/store';
import { ACTU_CATEGORY_EVENEMENT, ACTU_CATEGORY_PTCE } from '../constant';
export const storeActus = writable([]);
export const storeActu = writable();
export const emptyActu = {
    id: 0,
    photo: "",
    title: "",
    subtitle: "",
    date: "",
    place: "",
    text: "",
    nb_column: 0,
    actu_category: 0,
    event_type: 0
};
export const storeProjets = derived([storeActus], ([$storeActus]) => {
    return $storeActus.filter(x => x.actu_category === ACTU_CATEGORY_PTCE);
});
let today = new Date();
export const storeEvents = derived([storeActus], ([$storeActus]) => {
    return ($storeActus.filter(x => x.actu_category === ACTU_CATEGORY_EVENEMENT && new Date(x.date) >= today)).reverse();
});
